import { type EChartsExtensionInstaller } from 'echarts/types/src/extension';
import { use, graphic } from 'echarts/core';
import {
  guideExampleExtension,
  componentExtensions,
  chartExtensions,
  graphicExtensions
} from './extension';

// @ts-ignore
// extension
use([
  guideExampleExtension,
  ...componentExtensions,
  ...chartExtensions
] as unknown as EChartsExtensionInstaller[]);

graphicExtensions.forEach(extInstall => extInstall(graphic));
